import { createAction, props } from '@ngrx/store';

export const WebSocketActions = {
	connect: createAction('[WebSocket] Connected'),
	read: createAction('[WebSocket] Incoming Payload', props<{ payload: any }>()),
};
